export const LOCAL_API_URL = `http://localhost:7071/api`;
export let deploymentURL = "";
export let AD_tenantID = "";
export let AD_appId = "";
export let AD_appSecret = "";
export let SUBSCRIPTION_KEY = "";
export let API_URL = "";
export let BACKEND_API_URL = "";
export let INSTRUMENTATION_KEY = ""

const env = process.env.NODE_ENV;

if (env === "production") {
    deploymentURL = "https://wd-advantage-appservice-ajcsgzg8bjeshdbz.centralus-01.azurewebsites.net/";
    SUBSCRIPTION_KEY = "09fc570d7ea2499ba47a9c6c346a56bf";
    INSTRUMENTATION_KEY = "bdb257c8-391b-4ce9-ac89-7dfb3b46b6a1";
    BACKEND_API_URL = `https://graybar-marginbrain-api-services.azure-api.net/wd-advantage-functionapp`;
} else if (env === "development") {
    deploymentURL = "https://wd-advantage-appservice-ajcsgzg8bjeshdbz.centralus-01.azurewebsites.net/";
    SUBSCRIPTION_KEY = "09fc570d7ea2499ba47a9c6c346a56bf";
    INSTRUMENTATION_KEY = "bdb257c8-391b-4ce9-ac89-7dfb3b46b6a1";
    BACKEND_API_URL = `https://graybar-marginbrain-api-services.azure-api.net/wd-advantage-functionapp`;
} else {
    deploymentURL = "https://wd-advantage-appservice-ajcsgzg8bjeshdbz.centralus-01.azurewebsites.net/";
    SUBSCRIPTION_KEY = "09fc570d7ea2499ba47a9c6c346a56bf";
    INSTRUMENTATION_KEY = "bdb257c8-391b-4ce9-ac89-7dfb3b46b6a1";
    BACKEND_API_URL = `https://graybar-marginbrain-api-services.azure-api.net/wd-advantage-functionapp`;
}